module.exports = __webpack_public_path__ + "static/media/doremi_00053.b9f6accc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/proj/doremi_00053.png
// module id = 254
// module chunks = 0